<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { computed } from 'vue'
import { cn } from '@ds/lib/utils'
import type { AlertVariants } from '.'
import { alertVariants } from '.'

const props = defineProps<{
  tone?: AlertVariants['tone']
  /**
   * Announce it when it appears. Off by default, and that is the point: the
   * registry hardcodes `role="alert"`, an assertive live region, so a note that
   * is simply *present* on the screen interrupts a screen reader every time its
   * step is opened. Set `polite` for something that appears in response to what
   * the user just did, `assertive` only for something that must interrupt.
   */
  live?: 'polite' | 'assertive'
  class?: HTMLAttributes['class']
}>()

const role = computed(() => {
  if (props.live === 'assertive') return 'alert'
  if (props.live === 'polite') return 'status'
  return undefined
})
</script>

<template>
  <div
    :class="cn(alertVariants({ tone }), props.class)"
    :role
  >
    <slot name="icon" />
    <div class="flex-1 min-w-0">
      <slot />
    </div>
  </div>
</template>
